import Slider, { Settings as CarouselSettings } from 'react-slick';
import styles from './MobileCarousel.module.css';

interface IMobileCarousel {
  children: JSX.Element[];
  settings: CarouselSettings;
  className?: string;
  desktopClass?: string;
  mobileClass?: string;
}

const MobileCarousel = ({
  children,
  settings,
  className = '',
  desktopClass = '',
  mobileClass = '',
}: IMobileCarousel) => {
  return (
    <div className={`mobileCarousel ${className}`}>
      <div className={`${styles.desktopOnly} ${styles[desktopClass]}`}>
        {children}
      </div>

      <div className={`${styles.mobileOnly} ${styles[mobileClass]}`}>
        <Slider {...settings}>{children}</Slider>
      </div>
    </div>
  );
};

export default MobileCarousel;
